import axios from "axios";

export default {
  state: {
    carrito: [],
  },
  getters: {
    carrito(state) {
      if (state.carrito.length == 0) {
        if (localStorage.getItem("carrito_time") !== null) {
          var time = localStorage.getItem("carrito_time");
          var d = new Date();
          var time_actual = d.getTime();
          if (time_actual - time < 30 * 60 * 30 * 1000) {
            //30 minutos durará el carrito
            if (localStorage.getItem("carrito") !== null) {
              //state.carrito = localStorage.getItem('carrito')
              return JSON.parse(localStorage.getItem("carrito"));
            }
          }
        }
      }
      return state.carrito;
    },
    carrito_actual(state) {
      return state.carrito;
      /*
      var carrito_actual = state.carrito.filter(reserva_nodo => {
        if(reserva_nodo.cantidad > 0)
          return true
        else
          return false
      })
      return carrito_actual
      */
    },
  },
  mutations: {
    vaciar_carrito(state) {
      state.carrito.splice(0);
    },
    guardar_carrito(state, carrito) {
      state.carrito = carrito;
      this.commit("recalcular_totales");
      return true;
    },
    actualizar_carrito_hijo(state, hijo) {
      state.carrito.forEach((ele, index_ele) => {
        if (ele.menor_id == hijo.menor_id) {
          var ele_nuevo = ele;
          ele_nuevo.hijo.nombre = hijo.nombre;
          ele_nuevo.hijo.apellidos = hijo.apellidos;
          ele_nuevo.hijo.fechaNacimiento = hijo.fechaNacimiento;
          ele_nuevo.hijo.colegio = hijo.colegio;
          ele_nuevo.hijo.alergias = hijo.alergias;
          ele_nuevo.hijo.abonado = hijo.abonado;
          state.carrito.splice(index_ele, 1, ele_nuevo);
        }
      });
      this.commit("recalcular_totales");
      return true;
    },
    quitar(state, index) {
      state.carrito[index].cantidad = 0;
      this.commit("recalcular_totales");
      return true;
    },
    quitar_reserva(state, index) {
      state.carrito[index].cantidad = 0;
      state.carrito[index].reserva = {
        estado: -1,
      };
      delete state.carrito[index].reserva_id;
      this.commit("recalcular_totales");
      return true;
    },
    desaparecer(state, index) {
      state.carrito.splice(index, 1);
      this.commit("recalcular_totales");
      return true;
    },
    rpgd(state, datos) {
      state.carrito[datos.index].rpgd = !state.carrito[datos.index].rpgd;
      this.commit("recalcular_totales");
      return true;
    },
    observaciones(state, datos) {
      if (typeof state.carrito[datos.index] !== "undefined") {
        state.carrito[datos.index].observaciones = datos.observaciones;
      }
      return true;
    },
    fotos(state, datos) {
      state.carrito[datos.index].fotos = !state.carrito[datos.index].fotos;
      this.commit("recalcular_totales");
      return true;
    },
    montana_aviso_legal_checked(state, datos) {
      if (!state.carrito[datos.index].montana_aviso_legal_checked)
        state.carrito[datos.index].montana_aviso_legal_checked = false;
      state.carrito[datos.index].montana_aviso_legal_checked =
        !state.carrito[datos.index].montana_aviso_legal_checked;
      this.commit("recalcular_totales");
      return true;
    },
    numero_gir_dni_checked(state, datos) {
      if (!state.carrito[datos.index].numero_gir_dni_checked)
        state.carrito[datos.index].numero_gir_dni_checked = false;
      state.carrito[datos.index].numero_gir_dni_checked =
        !state.carrito[datos.index].numero_gir_dni_checked;
      this.commit("recalcular_totales");
      return true;
    },
    cantidad(state, datos) {
      state.carrito[datos.index].cantidad = datos.cantidad;
      state.carrito[datos.index].tpv_id = datos.tpv_id;
      let carr = state.carrito[datos.index];
      carr.cantidad = datos.cantidad;
      carr.tpv_id = datos.tpv_id;
      state.carrito.splice(datos.index, carr);
      this.commit("recalcular_totales");
      return true;
    },
    extra_cantidad(state, datos) {
      state.carrito[datos.index].extras[datos.extra_index].cantidad =
        datos.cantidad;
      this.commit("recalcular_totales");
      return true;
    },
    recalcular_totales(state) {
      state.carrito.forEach((reserva_nodo, index) => {
        state.carrito.precio_extras = 0;
        var precio_extras = 0;
        reserva_nodo.extras.forEach((extra, extra_index) => {
          state.carrito[index].extras[extra_index].precio_total =
            state.carrito[index].extras[extra_index].extra.precio *
            state.carrito[index].extras[extra_index].cantidad;
          precio_extras =
            precio_extras +
            state.carrito[index].extras[extra_index].precio_total;
        });
        state.carrito[index].precio_extras = precio_extras;
        state.carrito[index].precio_total =
          state.carrito[index].precio_extras + state.carrito[index].precio_nodo;
      });
      localStorage.setItem("carrito", JSON.stringify(state.carrito));
      var d = new Date();
      localStorage.setItem("carrito_time", d.getTime());
    },
    actualizar_estado(state, datos) {
      state.carrito.forEach((reserva_nodo, index) => {
        if (reserva_nodo.reserva.id == datos.reserva_id)
          state.carrito[index].reserva.estado = datos.estado;
      });
      this.commit("recalcular_totales");
      return true;
    },
  },
  actions: {
    vaciar_carrito(context) {
      context.commit("vaciar_carrito");
    },
    guardar_carrito(context, carrito) {
      context.commit("guardar_carrito", carrito);
    },
    estado(context, datos) {
      axios.defaults.baseURL = process.env.VUE_APP_API_URL;
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.getters["auth/token"];
      if (context.getters["auth/loggedIn"]) {
        axios.get("/reserva/estado/" + datos.reserva_id).then((response) => {
          context.commit("actualizar_estado", {
            reserva_id: datos.reserva_id,
            estado: response.data.estado,
          });
        });
      }
    },
  },
};
